import * as actions from "./rateApproveType"

export const rateApprovePreview = (): actions.RateApproveRequest => {
    return {
        type: actions.RATE_APPROVE_PREVIEW
    }
}

export const rateApproveUpdate = (payload: any): actions.RateApproveUpdate => {
    return {
        type: actions.RATE_APPROVE_UPDATE,
        payload
    }
}

export const rateApproveUpdateAll = (payload: any): actions.RateApproveUpdateAll => {
    return {
        type: actions.RATE_APPROVE_UPDATE_ALL,
        payload
    }
}

export const rateApproveProcessSuccess = (payload: any): actions.RateApproveProcessSuccess => {
    return {
        type: actions.RATE_APPROVE_PROCESS_SUCCESS,
        payload
    }
}

export const rateApproveDataSourceUpdate = (payload: any): actions.RateApproveDataSourceSuccess => {
    return {
        type: actions.RATE_APPROVE_DATASOURCE_SUCCESS,
        payload
    }
}

export const rateApproveViewSummary = (payload: actions.ViewSummaryInputValueType): actions.RateApproveViewSummary => {
    return {
        type: actions.RATE_APPROVE_VIEW_SUMMARY,
        payload
    }
}

export const rateApproveViewSummaryDataSource = (payload: any): actions.RateApproveViewSummaryDataSource => {
    return {
        type: actions.RATE_APPROVE_VIEW_SUMMARY_DATASOURCE,
        payload
    }
}

export const rateApproveProcessReset = () => {
    return {
        type: actions.RATE_APPROVE_PROCESS_RESET
    }
}

export const rateApproveReset = () => {
    return {
        type: actions.RATE_APPROVE_RESET
    }
}

